<template>
  <div class="Rank">
    <my_rank v-if="me" :info="myRank"></my_rank>
    <rank v-else></rank>
  </div>
</template>

<script>
  // @ is an alias to /src

  import MyRank from '@/components/rank/MyRank.vue'
  import Rank from '@/components/rank/Rank.vue'

  export default {
    name: 'Rank',
    computed: {
      user() {
        return this.$store.state.auth.user
      },
      group() {
        return ['小学组', '中学组', '开放组']
      },
      me() {
        return parseInt(this.$route.params.me)
      }
    },
    data() {
      return {
        myRank: {
          '姓名': '__',
          '组别': '__',
          '全国排名': '__',
          '区域排名': '__',
          '状态': '__'
        }
      }
    },
    mounted() {
      if (!this.user && this.me) {
        this.$router.push({
          name: 'account',
          params: {type: 'login'}
        })
      }
      else {
        if (this.user && this.user.enrolled) {
          this.$http.get('/api/rank?user_id=' + this.user.id)
            .then(res => {
              this.myRank = {
                '姓名': res.extra.username,
                '组别': this.group[res.extra.round.group - 1],
                '全国排名': res.extra.rank,
                '区域排名': res.extra.area_rank,
                /* '区域': res.extra.area_name, */
                '积分': res.extra.score,
                /* '排名': res.extra.rank, */
              }
            })
        }
        else {
          this.myRank = {
            '姓名': this.user.name,
            '组别': '/',
            '区域排名': '/',
            '状态': '未报名'
          }
        }
      }
    },

    components: {
      my_rank: MyRank,
      rank: Rank
    }
  }
</script>

<style scoped>
  .wait{
    margin: 200px;
    text-align: center;
    font-size: xx-large;

  }
</style>